import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './iconButton.scss';

const IconButton = React.forwardRef(function IconButton(
  {
    label,
    icon,
    indicator = false,
    indicatorLabel,
    type = 'button',
    disabled = false,
    className,
    onClick,
    ...rest
  },
  ref
) {
  const accessibleName =
    indicator && indicatorLabel ? `${label}, ${indicatorLabel}` : label;

  return (
    <button
      ref={ref}
      className={classNames(styles.iconButton, className)}
      type={type}
      aria-label={accessibleName}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      {indicator && <span className={styles.indicator} aria-hidden="true" />}
    </button>
  );
});

IconButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  indicator: PropTypes.bool,
  indicatorLabel: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default IconButton;
